module.exports = __webpack_public_path__ + "media/images/nipabrew-a829c182c40e271636e2cb23a3bdf065.png";